var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3536 4.64645C10.5488 4.84171 10.5488 5.15829 10.3536 5.35356L4.20712 11.4999H21C21.2761 11.4999 21.5 11.7238 21.5 11.9999C21.5 12.2761 21.2761 12.4999 21 12.4999H4.20711L10.3536 18.6464C10.5488 18.8416 10.5488 19.1582 10.3536 19.3535C10.1583 19.5487 9.84171 19.5487 9.64645 19.3535L2.64645 12.3535C2.55268 12.2597 2.5 12.1325 2.5 11.9999C2.5 11.8673 2.55268 11.7401 2.64645 11.6464L9.64645 4.64644C9.84171 4.45118 10.1583 4.45119 10.3536 4.64645Z",
    fill: "#0A213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ce0ae319070a6ac23afe43136a7c74df.svg";
export { ForwardRef as ReactComponent };